import { memo } from 'react';
import { IconAgent } from '@optimizely/axiom-icons';
import { NodeProps } from '@xyflow/react';

import { NodeConnectionTypes, NodeTypeCategory } from '../../types/connections';
import { NODE_TYPE } from '../../types/node';
import { defineNode } from '../../utils/node-factory';
import { BaseNodeRenderer } from '../components/renderers/BaseNodeRenderer/BaseNodeRenderer';

/**
 * Configuration for the Specialized Agent node type.
 * Executes tasks using a specialized agent with specific capabilities.
 */
export const specializedAgentConfig = defineNode({
  description: {
    displayName: 'Specialized Agent',
    name: NODE_TYPE.SPECIALIZED,
    description: 'Execute tasks using a specialized agent with specific capabilities',
    iconInfo: {
      icon: IconAgent,
      color: 'fg.information',
    },
    category: NodeTypeCategory.AGENT,
    input: {
      type: NodeConnectionTypes.Main,
      allowTriggers: true,
      filter: {
        allowedNodeTypes: [
          { type: NODE_TYPE.SPECIALIZED, maxConnections: 10 },
          { type: NODE_TYPE.EMAIL, maxConnections: 10 },
          { type: NODE_TYPE.WEBHOOK, maxConnections: 10 },
          { type: NODE_TYPE.SCHEDULED, maxConnections: 10 },
          { type: NODE_TYPE.MESSAGE, maxConnections: 10 },
          { type: NODE_TYPE.CONDITIONAL, maxConnections: 10 },
          { type: NODE_TYPE.FOR_LOOP, maxConnections: 10 },
          { type: NODE_TYPE.CONDITION, maxConnections: 10 },
          { type: NODE_TYPE.NESTED_WORKFLOW, maxConnections: 10 },
        ],
      },
    },
    output: {
      type: NodeConnectionTypes.Main,
      maxConnections: 1,
    },
    properties: [
      {
        displayName: 'Name',
        name: 'name',
        type: 'string',
        required: true,
        default: '',
        description: 'A descriptive name for this step',
      },
      {
        displayName: 'Description',
        name: 'description',
        type: 'string',
        required: false,
        default: '',
        description: 'Optional description of what this step does',
      },
    ],
    defaults: {
      name: 'Specialized Agent',
      parameters: {
        name: '',
        description: '',
      },
    },
  },

  render: memo(function SpecializedAgentRenderer(props: NodeProps) {
    return <BaseNodeRenderer {...props} />;
  }),
});
